import { View } from 'react-native';
import { useTheme } from 'react-native-paper';

// A plain bar instead of Paper's ProgressBar: the ProgressBar measures itself
// on layout and renders empty in the first frame on web, and the bar must keep
// a visible track in both themes.
export const LimitBar = ({
  ratio,
  color,
  height = 8,
  accessibilityLabel,
  testID,
}: {
  ratio: number;
  color: string;
  height?: number;
  accessibilityLabel?: string;
  testID?: string;
}) => {
  const theme = useTheme();
  const pct = Math.round(Math.min(1, Math.max(0, ratio)) * 100);
  return (
    <View
      testID={testID}
      accessible
      accessibilityRole="progressbar"
      accessibilityLabel={accessibilityLabel}
      accessibilityValue={{ min: 0, max: 100, now: pct }}
      style={{
        height,
        borderRadius: height / 2,
        backgroundColor: theme.dark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.10)',
        overflow: 'hidden',
      }}
    >
      <View style={{ width: `${pct}%`, height: '100%', borderRadius: height / 2, backgroundColor: color }} />
    </View>
  );
};
